import { Controller } from '@hotwired/stimulus';
import { agencyFees, agencyFeesRateLabel } from '../../../shared/helpers/agencyFeesHelper';

export default class extends Controller {
  static targets = [
    'agencyFees',
    'netSellerWithClassicAgency',
    'netSellerWithHosman',
    'agencyFeesDiff',
    'priceRef',
    'firstCategory',
    'secondCategory',
    'thirdCategory',
    'fourthCategory',
    'category',
    'yourCommission',
    'container',
    'feesShow'
  ];

  static values = {
    feesRegion: String,
    price: String
  }

  connect = () => {
    this.price = this.priceValue
    this.feesRegion = this.feesRegionValue;
    this.handleAgencyFees()
    this.handleHTMLContent()
    this.handleHTMLDisplay()
  }

  handleAgencyFees = () => {
    this.agencyFees = agencyFees(
      this.feesRegion,
      this.price,
      false
    );
  }

  handleHTMLContent = () => {
    this.classicAgencyRate = Number(this.price) < 150_000 ? 6.0 : 5.78
    this.feesWithClassicAgency = Number(this.price) * (this.classicAgencyRate / 100)

    this.agencyFeesTarget.innerHTML = agencyFeesRateLabel(this.feesRegion, this.price) || this.formatPriceHelper(this.agencyFees)

    this.netSellerWithHosmanTarget.innerHTML = this.formatPriceHelper(Number(this.price) - Number(this.agencyFees))
    this.netSellerWithClassicAgencyTarget.innerHTML = this.formatPriceHelper(Number(this.price) - Number(this.feesWithClassicAgency))

    if ((this.feesWithClassicAgency - this.agencyFees) < 1000) {
      this.feesShowTargets.forEach(feesShowDiv => {
        feesShowDiv.classList.add('hidden');
      })
    }

    this.agencyFeesDiffTarget.innerHTML = this.formatPriceHelper(this.feesWithClassicAgency - this.agencyFees)
    this.priceRefTarget.innerHTML = this.formatPriceHelper(Number(this.price))
  }

  handleHTMLDisplay = () => {
    // 'Strong points' trad condition according to hosman prices steps
    if (Number(this.price) <= 200000) {
      this.firstCategoryTarget.classList.toggle('hidden')
    } else if (Number(this.price) <= process.env.PREMIUM_START_VALUE_REGIONS) {
      this.secondCategoryTarget.classList.toggle('hidden')
    } else if (Number(this.price) <= process.env.PREMIUM_START_VALUE_PARIS) {
      this.thirdCategoryTarget.classList.toggle('hidden')
    } else {
      this.fourthCategoryTarget.classList.toggle('hidden')
    }
  }

  formatPriceHelper = (price) => {
    const options = { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 };
    const priceString = price.toLocaleString('fr-FR', options);
    return priceString;
  }
}
